import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const bulkDeleteSchema = z
  .object({
    ids: z.array(z.string()).min(1).optional(),
    emails: z.array(z.string().email()).min(1).optional(),
  })
  .refine((v) => (v.ids?.length ?? 0) + (v.emails?.length ?? 0) > 0, {
    message: "ids or emails is required",
    path: ["ids"],
  });

export class BulkDeleteDto extends createZodDto(bulkDeleteSchema) {}

export const bulkDeleteResultSchema = z.object({
  success: z.boolean(),
  id: z.string().optional(),
  email: z.string().email().optional(),
  error: z.string().optional(),
});
